import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetInventoryAPiService from './AssetInventoryAPiService';
import { setAssessmentCreationSuccess } from 'Store/AssetInventory/Assessments/AssessmentAction';
import { CREATE_ASSESSMENT } from 'Store/AssetInventory/Assessments/AssessmentTypes';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';


function* createAssessment(assessment: any): any {
    try {
        yield put(globalLoaderText("Saving Assessment...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/saveassessment`,
            apiMethod :  apiMethod.POST,
            payload : assessment.assessment
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAssessmentCreationSuccess("success"))
        }
        else {
            yield put(setAssessmentCreationSuccess("failed"))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setAssessmentCreationSuccess("failed"))
    }
}

function* watchCreateAssement() {
    yield takeEvery(CREATE_ASSESSMENT, createAssessment)
}

export default function* combinedSaga() {
    yield all([
        watchCreateAssement()
    ])
}